var map = {
	"./X33-Mall_small.jpg": 919,
	"./all.svg": 920,
	"./apple-watch.png": 921,
	"./b-headphone.png": 922,
	"./coin.svg": 923,
	"./delete-btn.svg": 924,
	"./iphone-pink.png": 925,
	"./love.svg": 926,
	"./mall-banner-cn.jpg": 927,
	"./mall-banner-id.jpg": 928,
	"./mall-banner-ms.jpg": 929,
	"./mall-banner.jpg": 930,
	"./mobile-bg.jpg": 931,
	"./price-high.svg": 932,
	"./price-low.svg": 933,
	"./shopping-cart.svg": 934,
	"./star.svg": 935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;